export const coerceInt = (v) => {
    const r = Number(v);
    if (!Number.isInteger(r)) {
        return undefined;
    }
    return r;
};
export const coerceIntOrThrow = (v, errorFactory) => {
    const int = coerceInt(v);
    if (int !== undefined) {
        return int;
    }
    throw errorFactory();
};
//# sourceMappingURL=number.js.map